
import { useState, useEffect } from 'react';
import { Message, Conversation } from '@/types';
import { useAuth } from '@/context/AuthContext';

export function useChatState() {
  const [messages, setMessages] = useState<Message[]>([]);
  const [conversations, setConversations] = useState<Conversation[]>([]);
  const [currentConversation, setCurrentConversation] = useState<Conversation | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);
  
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      setMessages([]);
      setConversations([]);
      setCurrentConversation(null);
    }
  }, [user]);

  return {
    messages,
    conversations,
    currentConversation,
    isProcessing,
    setMessages,
    setConversations,
    setCurrentConversation,
    setIsProcessing,
    user
  };
}
